// Nhãn tab / bộ lọc / độ ưu tiên của HỘP THƯ PHÊ DUYỆT — MỘT bản cho sidebar
// (components/layout/sidebar/ApprovalsSecondaryNav.jsx) và trang (pages/approvals/ApprovalInboxPage.jsx).
//
// Trước 10/10/2026 sidebar khai lại cùng bộ chữ ở dạng chuỗi trần (không macro) ⇒ bản tiếng Anh của
// Site Connect hiện "Nhiệm vụ / Đơn của tôi / Cần thực hiện…" ngay thanh bên, trong khi trang chính
// (FILTER_LABELS có msg``) đã dịch. Hai bản chép thì lệch — gom về đây.
//
// Đọc nhãn: i18n._(APPROVAL_FILTER_LABELS[key]) ở MỌI chỗ đọc (hằng ngoài component — xem docs/I18N.md).
// Khoá (pending/upcoming/…) là giá trị gửi BE qua ?filter= — KHÔNG dịch, KHÔNG đổi.

import { msg } from '@lingui/core/macro';

/** Hai tab trên cùng: việc chờ tôi xử lý · đơn tôi gửi. */
export const APPROVAL_TAB_LABELS = {
  tasks: msg({ message: 'Nhiệm vụ', context: 'tab hộp thư phê duyệt' }),
  sent: msg`Đơn của tôi`,
};

/** Bộ lọc của hai tab (tasks: pending…cc · sent: active/done/rejected). */
export const APPROVAL_FILTER_LABELS = {
  pending: msg`Cần thực hiện`,
  upcoming: msg`Sắp đến lượt`,
  completed: msg`Hoàn thành`,
  ended: msg({ message: 'Kết thúc', context: 'bộ lọc đơn phê duyệt' }),
  cc: msg`Được CC`,
  active: msg`Đang xử lý`,
  done: msg`Đã hoàn tất`,
  rejected: msg`Bị từ chối`,
};

/** Độ ưu tiên của đơn (khoá = giá trị `urgency` BE trả). */
export const APPROVAL_PRIORITY_LABELS = {
  urgent: msg`Khẩn cấp`,
  high: msg`Cao`,
  normal: msg`Bình thường`,
  low: msg`Thấp`,
};

/** Nhóm đơn không gắn được mẫu nào (tên mẫu rỗng). */
export const APPROVAL_OTHER_TEMPLATE = msg`Khác`;
